import React, { useState, useEffect, useCallback } from "react";
import Pagination from "@material-ui/lab/Pagination";
import PaginationItem from "@material-ui/lab/PaginationItem";

import IntegrationsService from "../../../../../../../services/IntegrationsService";
import { Link, useLocation } from "react-router-dom";
import { calcCountPages, calcOffset } from "../../../../../../../utils/pagination";
import ScreenHeader from "../../../../../components/ScreenHeader";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import EmptyResult from "../../../../../../components/EmptyResult";
import IntegrationItem from "./components/IntegrationItem";
import ModalAddNewIntegration from "./modals/modalNewIntegration";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function CanvasScreen(props) {
  const integrationsLoading = Array.from(Array(5).keys());
  const [integrations, setIntegrations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModalAddNewIntegration, setOpenModalAddNewIntegration] = useState(false);
  // const PROFILE = props.profile;

  // pagination
  const location = useLocation();
  let query = useQuery();
  const [countPages, setCountPages] = useState(0);
  const page = parseInt(query.get("page")) || 1;
  const paginationLimit = 7;

  // Get users data
  const fetchIntegrationData = useCallback(async () => {
    setIsLoading(true);
    try {
      const result = await IntegrationsService.listIntegrationsLMS({
        fields: "id,domain,client_id,client_secret,integration_backend,integration_backend,is_active,is_active,created_datetime,modified_datetime,is_authorized,authorization_url,redirect_uri,status,sync_get_time,sync_post_time,last_execution_summary",
        limit: paginationLimit,
        offset: calcOffset(page, paginationLimit)
      });
      setIntegrations(result.data.results);
      setCountPages(calcCountPages(result, paginationLimit));
      setIsLoading(false);
    } catch (error) {
      setIntegrations([]);
    }
  }, [page]);

  const removeIntegrationFromList = integrationId => {
    const newIntegrations = integrations.filter((item, index) => item.id !== integrationId);
    setIntegrations(newIntegrations);
  };

  const updateIntegrationFromList = () => {    
    fetchIntegrationData();        
  };

  useEffect(() => {
    // Query Params changued
    fetchIntegrationData();
  }, [fetchIntegrationData, location.search]);

  const handleClickOpenModalAddNewIntegration = () => {
    setOpenModalAddNewIntegration(true);
  };

  const handleClickCloseModalAddNewIntegration = () => {
    setOpenModalAddNewIntegration(false);
  };

  return (
    <div
      id="integration-screen"
      className={`${props.className} dashboard-container`}
    >

      {/* Header */}
      <ScreenHeader title="Integrations">
        <Button
          variant="outlined"
          color="primary"
          onClick={handleClickOpenModalAddNewIntegration}
          endIcon={<AddIcon />}
        >
          {" "}
          Add Integration
        </Button>
      </ScreenHeader>

      {/* Body */}
      <div className="content">
        <div className="courses-list" style={{ minHeight: "36em" }}>
          {isLoading ? (
            // Generate 5 integration of loading data
            integrationsLoading.map(i => <IntegrationItem key={i} loading />)
          ) : // Show integration
          integrations.length > 0 ? (
            integrations.map(integration => (
              <IntegrationItem
                data={integration}
                key={integration.id}
                removeIntegration={removeIntegrationFromList}
                updateIntegrationFromList={updateIntegrationFromList}
                openSnack={props.openSnack}
              />
            ))
          ) : (
            // Show Empty Integrations
            <EmptyResult />
          )}
        </div>
        <Pagination
          page={page}
          count={countPages}
          color="primary"
          size="large"
          renderItem={item => (
            <PaginationItem
              component={Link}
              to={`/dashboard/integrations${
                item.page === 1 ? "" : `?page=${item.page}`
              }`}
              {...item}
            />
          )}
        />
      </div>

      {/* Modal Dialog for Remove Data */}
      <ModalAddNewIntegration
        open={openModalAddNewIntegration}
        onClose={handleClickCloseModalAddNewIntegration}
        updateIntegrationFromList={updateIntegrationFromList}
      />

    </div>
  );
}

export default CanvasScreen;
